import React from "react";
import "../../../resources/styles/auth.scss";
import { api } from "../../../controllers/api";

function ForgotPassword() {
  const [loading, setLoading] = React.useState(false);
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const email = (
      (e.target as HTMLFormElement).elements[0] as HTMLInputElement
    ).value.trim();

    try {
      setLoading(true);
      let req = await fetch(api + "/forgot-customer-password?email=" + email);
      alert("Password reset link sent to your email address");
    } catch (error) {
      console.error("Error sending password reset request:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="forgot-password-con">
      {" "}
      <div className="forgot-password-con__form">
        <h2>Forgot Password</h2>
        <p>Please enter your email address to reset your password.</p>
        <form onSubmit={handleSubmit}>
          <div className="input-con">
            <input type="email" placeholder="Email Address" required />
            <button disabled={loading} type="submit">
              Reset Password
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default ForgotPassword;
